import { useState, Fragment, useEffect, useCallback, memo } from "react";
import { Button } from "core/components/form-controls";
import BottomSwiper from "core/components/BottomSwiper";
import { _t } from "core/language";
import Icon from 'core/assets/icons';
import { useCustomNavigate } from 'core/hooks/useCustomNavigate'
import { RouterName } from "core/router";
import { useResetAiChef } from "./../../hooks/aiChef";
import { CImagePicker } from "core/components/form-controls";
import { useGetImagePicker } from "core/hooks/useImagePicker";
import { ImageTypeEnums, OpenImagePickerType } from "core/store/upload/actions";

const SelectSwiper = ({setIsDrawerOpen, type = 'aiChefImageRecipe'}: any) => {
  const navigate = useCustomNavigate()
  const { onReset } = useResetAiChef()
  const aiChefImageRecipe = useGetImagePicker(
    type,
    false
  )
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const onOpen = () => setIsOpen(true);
  const onClose = () => {
    setIsOpen(false);
    setTimeout(() => {
      setIsDrawerOpen(false);
    }, 300)
  }

  const toggleDrawer = useCallback(() => {
    if (isOpen) {
      onClose()
    } else {
      onOpen()
    }
  }, [isOpen]);

  useEffect(() => {
    onOpen()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const goToAI = useCallback(() => {
    onReset()
      // close drawer
    onClose()
    if(type && type !== 'avatar'){
      navigate(RouterName.AI_CHEF_RECIPE_LOADING)
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // has new image and image is uploading
    // go to AI analysis image
    if (aiChefImageRecipe && aiChefImageRecipe.uploading) {
      goToAI();
    }
  }, [aiChefImageRecipe?.uploading, goToAI])

  return (
    <Fragment>
      <BottomSwiper
        isOpen={isOpen}
        toggleDrawer={toggleDrawer}
        zIndex={50}
      >
        <div className="flex flex-col gap-3">
          <CImagePicker
            name={type}
            property={ImageTypeEnums.TEMPORARY}
            openType={OpenImagePickerType.CAMERA}
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('aiChef.add_image_by_camera')}
                classBtn="w-full [box-shadow:none!important]"
                primary
                icon={Icon.RecipeSelectImageByCamera}
              />,
              loading: <div></div>,
              preview: () => 
                <div></div>
            }}
          />

          <CImagePicker
            name={type}
            property={ImageTypeEnums.TEMPORARY}
            openType={OpenImagePickerType.GALLERY}
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('aiChef.add_image_by_gallery')}
                classBtn="w-full"
                primary
                outline
                icon={Icon.RecipeSelectImageByGallery}
              />,
              loading: <div></div>,
              preview: () => 
                <div></div>
            }}
          />
        </div>
      </BottomSwiper>
    </Fragment>
  )
}

export default memo(SelectSwiper)
